import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './AboutSection.css';
import aboutImg from '../../Assets/Hero/About.webp';

const AboutSection = () => {
  // Container logic to stagger each child element (H2, P, Button)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.25, // Delay between each text element's start
        delayChildren: 0.1     // Initial delay before the first element starts
      },
    },
  };

  // Text reveal: slides up 40px and fades in
  const textRevealVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.215, 0.61, 0.355, 1.0] // Smooth "cubic-bezier" for a premium feel
      },
    },
  };

  // Image reveal: slides from the left with a slight scale-up
  const imageRevealVariants = {
    hidden: { opacity: 0, x: -60, scale: 0.98 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 1.2, ease: "easeOut" },
    },
  };

  return (
    <section className="about-section-vh">
      <div className="about-container-fluid">

        {/* Left Side: Image reveal */}
        <div className="about-image-col">
          <motion.div
            className="img-reveal-wrapper"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
            variants={imageRevealVariants}
          >
            <img src={aboutImg} alt="Logistics Excellence" className="about-main-img" />
          </motion.div>
        </div>

        {/* Right Side: Sequential Text reveal */}
        <motion.div
          className="about-text-col"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
        >
          <div className="text-top-group">
            <motion.h2 variants={textRevealVariants} className="title-red">
              Built On Legacy.<br />
              Driven By Logistics<br />
              Excellence.
            </motion.h2>

            <motion.p variants={textRevealVariants} className="desc-muted">
              We are a trusted automobile logistics partner delivering
              safe, compliant, and reliable vehicle transportation
              across India. Backed by four decades of experience,
              specialised carriers, and pan-India operations, we
              support leading OEMs with precision and care.
            </motion.p>
          </div>

          <motion.div variants={textRevealVariants} className="button-bottom-group">
            <Link to="/about" className="about-cta-btn">
              About Janta <span className="arrow-icon">→</span>
            </Link>
          </motion.div>
        </motion.div>

      </div>
    </section>
  );
};

export default AboutSection;